import React from "react";
import leaderimg from  "../pictures/leadershipimg.png";

const LeadershipAwards = () => {
  return (
    <>
      <div className="Leadership_Award_container">
        <div className="Leadership_Award_img">
          <img src={leaderimg} alt="not" />
        </div>
        <p>
          TIME Cybermedia Private Limited award the International Leadership
          Award to honor outstanding performance in a wide range of categories
          and industries to ensure that achievements in across all fields are
          acknowledged. The accomplishments of the awardees raise the bar and
          inspire others to advance their business goals by setting a high
          benchmark.
        </p>
        <p>
          The International Leadership Award is presented to reward quality and
          perseverance with a view to recognize enterprises which have
          demonstrated excellence in their industry whilst also contributing to
          the progress and development of the country. The winners and
          recipients of the award gain recognition as well as acknowledgement
          for their top-class achievement and ranking in their industry. The
          event is a conglomeration of the elites from the various industries
          and participant organizations get an opportunity to showcase their
          brand and gain global exposure.
        </p>

        <button>Register now</button>
      </div>
    </>
  );
};

export default LeadershipAwards;
